module.exports = "/virtual-football/img/video/clubs/france/lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/france/lyon.png
// module id = 291
// module chunks = 6